import { useTranslation } from 'react-i18next'
import { StoryblokComponent } from '@storyblok/react'
import { LargeDialog } from 'ui/src/components/Dialog/LargeDialog'
import { visuallyHidden } from 'ui/src/utils/visibility.css'
import { usePriceCalculatorNonTierCoverageInfo } from '../priceCalculatorAtoms'

export function NonCoverageInfoDialogContent() {
  const { t } = useTranslation(['common', 'purchase-form'])
  const coverageInfo = usePriceCalculatorNonTierCoverageInfo()

  return (
    <LargeDialog.Content>
      <LargeDialog.CloseIconButton aria-label={t('common:DIALOG_CLOSE')} />
      <LargeDialog.Heading className={visuallyHidden}>
        {t('purchase-form:COVERAGE_DIALOG_TRIGGER_HEADER')}
      </LargeDialog.Heading>
      {coverageInfo.map((blok) => (
        <StoryblokComponent key={blok._uid} blok={blok} nested={true} />
      ))}
    </LargeDialog.Content>
  )
}
